import { isEnumValue, isObject } from '@principle-theorem/shared';
import { isString } from 'lodash';

export const PATIENT_PORTAL_DISPATCHER =
  'http-patientPortal-patientPortalDispatcher';

export enum OnlineBookingAction {
  GetBookingSuggestions = 'onlineBooking.getBookingSuggestions',
  GetOnlineBookingData = 'onlineBooking.getOnlineBookingData',
  SubmitBookingRequest = 'onlineBooking.submitBookingRequest',
  CreateDepositPaymentIntent = 'onlineBooking.createDepositPaymentIntent',
  ResolveDeposit = 'onlineBooking.resolveDeposit',
  TrackPageView = 'onlineBooking.trackPageView',
}

export enum PatientAction {
  GetPatientConfirmAppointmentInfo = 'patient.getPatientConfirmAppointmentInfo',
  GetPatientGapOffer = 'patient.getPatientGapOffer',
  GetPatientInvoice = 'patient.getPatientInvoice',
  GetPatientMedicalHistoryFormData = 'patient.getPatientMedicalHistoryFormData',
  GetPatientFormsData = 'patient.getPatientFormsData',
  SubmitPatientDetailsForm = 'patient.submitPatientDetailsForm',
  SubmitPatientMedicalForm = 'patient.submitPatientMedicalForm',
  SubmitAccPatientForm = 'patient.submitAccPatientForm',
  Unsubscribe = 'unsubscribe',
  SubmitPatientForm = 'patient.submitPatientForm',
  GetDepositRequest = 'patient.getDepositRequest',
  CreateDepositPaymentIntent = 'patient.createDepositPaymentIntent',
}

export type OnlineBookingActionRequest<T> = {
  action: OnlineBookingAction;
  recaptchaToken: string;
  data: T;
};

export type PatientActionRequest<T> = {
  action: PatientAction;
  recaptchaToken: string;
  data: T;
};

export function isOnlineBookingActionRequest<T>(
  request: unknown
): request is OnlineBookingActionRequest<T> {
  return (
    isObject(request) &&
    'action' in request &&
    isEnumValue(OnlineBookingAction, request.action) &&
    'data' in request &&
    isObject(request.data) &&
    'recaptchaToken' in request &&
    isString(request.recaptchaToken)
  );
}

export function isPatientActionRequest<T>(
  request: unknown
): request is PatientActionRequest<T> {
  return (
    isObject(request) &&
    'action' in request &&
    isEnumValue(PatientAction, request.action) &&
    'data' in request &&
    isObject(request.data) &&
    'recaptchaToken' in request &&
    isString(request.recaptchaToken)
  );
}
